import React, { FC, memo, useState } from "react";
import "./SkeletonImage.scss";

interface SkeletonImageProps {
  src: string;
  alt: string;
  width?: string | number;
  height?: string | number;
  className?: string;
  wrapperClassName?: string;
}

export const SkeletonImage: FC<SkeletonImageProps> = memo(
  function SkeletonImage({
    src,
    alt,
    width,
    height,
    className = "",
    wrapperClassName = "",
    children,
  }) {
    const [loaded, setLoaded] = useState(false);

    return (
      <div className={`skeleton-image-wrapper ${wrapperClassName}`}>
        {!loaded && <div className="skeleton-image-placeholder" />}

        <img
          src={src}
          alt={alt}
          width={width}
          height={height}
          loading="lazy"
          onLoad={() => setLoaded(true)}
          className={`skeleton-image ${loaded ? "loaded" : ""} ${className}`}
        />

        {children}
      </div>
    );
  }
);
